import { render } from "./FileTime.vue?vue&type=template&id=bba9a900"
import script from "./FileTime.vue?vue&type=script&lang=js"
export * from "./FileTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__